enum EVendorRoutePath {
  SCORING = '/vendor/scoring',
}

export default EVendorRoutePath;
